// extracted by mini-css-extract-plugin
export default {"chromePicker":"Workshop_chromePicker__JgSrB","penModeCanvas":"Workshop_penModeCanvas__TdoTx","stickerModeCanvas":"Workshop_stickerModeCanvas__DLJVW"};